// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as WordFlyersUi$LiteracyplanetClientSxEntry from "./WordFlyersUi.res.mjs";
import * as WordFlyersData$LiteracyplanetClientSxEntry from "./WordFlyersData.res.mjs";

function WordFlyersIndexContainer(props) {
  return React.createElement(WordFlyersData$LiteracyplanetClientSxEntry.Provider.make, {
              optionalJourney: props.optionalJourney,
              optionalGate: props.optionalGate,
              children: React.createElement(WordFlyersUi$LiteracyplanetClientSxEntry.make, {
                    onBack: props.onBack,
                    onActivityClick: props.onActivityClick,
                    onMenuClick: props.onMenuClick
                  })
            });
}

var make = WordFlyersIndexContainer;

export {
  make ,
}
/* react Not a pure module */
